import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { resetPassword } from '../../actions/authActions';
import { clearErrors } from '../../actions/errorActions';
import history from "../../history";
import axios from 'axios';
import { toast } from 'react-toastify';

const initialState = {
  password: '',
  confPassword: '',
  passwordErr: '',
  token: null,
  err: null
};

const noErrorState = {
  passwordErr: '',
  err: null
};

class PasswordReset extends Component {
  state = initialState;

  static propTypes = {
    error: PropTypes.object.isRequired,
    resetPassword: PropTypes.func.isRequired,
    clearErrors: PropTypes.func.isRequired
  };

  componentDidMount = () => {
    const { token } = this.props.match.params;
    this.setState({ token });

    axios.get(`${process.env.REACT_APP_API_SERVER_URL}/users/checkToken/${token}`)
      .then(res => {
        this.setState({ checking: false });
      })
      .catch((err) => {
        if (err) {
          this.setState({ checking: false });
          history.push({
            pathname: '/'
          })
          toast.error(`${err.response.data.msg}`, {
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
        }
      })
  }

  componentDidUpdate(prevProps) {
    const { error } = this.props;
    if (error !== prevProps.error) {
      if (error.id === 'PASSWORD_RESET_FAIL') {
        if (error.msg.msg) {
          this.setState({ err: error.msg.msg });
        } else {
          this.setState({ err: 'An internal error occurred.' });
        }
      } else {
        this.setState({
          err: null
        });
      }
    }
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let passwordErr = "";
    let err = "";

    if ((this.state.password.length < 5) || (!/\d/.test(this.state.password))) {
      passwordErr = 'Password must be 5 or more characters and contain at least 1 number.';
    }
    if ((this.state.password !== this.state.confPassword)) {
      passwordErr = 'Passwords do not match.';
    }

    if (passwordErr || err) {
      this.setState({ passwordErr, err });
      return false;
    }
    return true;
  }

  onSubmit = e => {
    e.preventDefault();

    const isValid = this.validate();
    if (isValid) {
      // clear form
      this.setState(noErrorState);

      const { token, password } = this.state;

      // Attempt to login
      this.props.resetPassword(token, password);
    }
  };

  render() {
    return (
      <div className="container max-w-xl mx-auto bg-white rounded-lg shadow-lg p-5 overflow-auto">
        <form onSubmit={this.onSubmit}>
          <h1 className="text-center text-2xl font-medium">Reset Your Password</h1>
          <p className="mt-4" htmlFor="password">New password:</p>
          {this.state.err ? <label className="text-red-600">{this.state.err}</label> : null}
          <input
            name="password"
            className="appearance-none block w-full bg-grey-200 text-grey-darker border border-grey-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-grey"
            id="grid-reset-password"
            type="password"
            placeholder="******************"
            autoComplete="new-password"
            value={this.state.password}
            onChange={this.onChange} />
          {this.state.passwordErr ? <label className="text-red-600">{this.state.passwordErr}</label> : null}
          <p className="mt-4" htmlFor="confirm-password">Confirm password:</p>
          {this.state.err ? <label className="text-red-600">{this.state.err}</label> : null}
          <input
            name="confPassword"
            className="appearance-none block w-full bg-grey-200 text-grey-darker border border-grey-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-grey"
            id="grid-reset-password-conf"
            type="password"
            placeholder="******************"
            autoComplete="new-password"
            value={this.state.confPassword}
            onChange={this.onChange} />
          <div className="float-right mt-8">
            <button className='block mt-4 p-1 pl-2 pr-2 lg:inline-block lg:mt-0 text-blue-800 hover:bg-blue-200 border border-blue-800 mr-2 bg-white rounded-full' onClick={() => history.push("/")} type="button"> Cancel </button>
            <button className='block mt-4 p-1 pl-2 pr-2 lg:inline-block lg:mt-0 text-white hover:bg-blue-600 mr-2 bg-blue-800 border border-blue-800 rounded-full'>Submit</button>
          </div>
        </form>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  error: state.error
});

export default connect(mapStateToProps, { resetPassword, clearErrors })(PasswordReset);